import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { ReactComponent as IconAdd } from '../../assets/icons/icon-add.svg';

const AddToFavoritesBtn = props => (
  <button
    className={
      !props.isFavorite
        ? `addToFav-btn ${props.className}`
        : `addToFav-btn addToFav-btn__active ${props.className}`
    }
    title={
      !props.isFavorite ? 'Añadir a favoritos' : 'Eliminar de mis favoritos'
    }
    onClick={props.onClick}
    type="button"
  >
    <IconAdd />
  </button>
);

AddToFavoritesBtn.propTypes = {
  className: PropTypes.string,
  isFavorite: PropTypes.bool,
  onClick: PropTypes.func
};

AddToFavoritesBtn.defaultProps = {
  className: '',
  isFavorite: false,
  onClick: null
};

export default AddToFavoritesBtn;
